/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from "react";
import Container from "@mui/material/Container";
import {
  Button,
  Box,
  Card,
  CardContent,
  Typography,
  CardActions,
  Grid,
} from "@mui/material";
import Navbar from "../../Navbar";
import axios from "axios";
import { UrlApi } from "../../../services/apirest";
import { logEventos } from "../../../services/services";
const TablaSuscripciones = () => {
  //obtener el usuario que este logueado
  const [usuario, setUsuario] = useState(
    () => localStorage.getItem("user") || ""
  );

  //traer las subscripciones para ver si el usuario esta subscripto o no
  const [suscripciones, setsuscripciones] = useState([]);

  //Data
  const [data, setData] = useState({
    usuario: usuario,
    modulo: null,
  });
useEffect(() => {
  logEventos(
    "acceso al menú Suscripciones",
   "Tablas Referencias", 
   "Suscripciones",
    localStorage.getItem("user"));
}, []);
  //obtener las suscripciones del usuario si es que las tiene
  const getSuscripciones = useCallback(async () => {
    try {
      const response = await fetch(UrlApi + "/suscripciones/" + usuario);
      if (!response.ok) {
        throw new Error("Error al obtener las suscripciones");
      }
      const data = await response.json();
      setsuscripciones(data);
    } catch (error) {
      console.error("Error en getSuscripciones:", error);
    }
  }, [usuario]);

  useEffect(() => {
    getSuscripciones();
  }, [getSuscripciones]);

  useEffect(() => {
    if (suscripciones.length > 0) {
      const suscripcionesSet = suscripciones.reduce((acc, sub) => {
        acc[sub.modulo] = true;
        return acc;
      }, {});
      setDisabledModules(suscripcionesSet);
    }
  }, [suscripciones]);

  // POST Y DELETE DE SUBSCRIPCIONES
  const guardarSuscripcion = async (modulo) => {
    setDisabledModules((prev) => ({ ...prev, [modulo]: true }));
    const nuevaData = { ...data, modulo };

    try {
      await axios.post(UrlApi + "/suscripciones/", nuevaData);
      console.log("Suscripción guardada correctamente.");
      getSuscripciones(); // Recargar la lista después de suscribirse
    } catch (error) {
      console.log("Error al guardar la suscripción:", error);
    }
  };

  //Cards con botones de subscripciones
  //desabilitar el boton una vez suscripto
  // Estado para manejar qué módulos están deshabilitados
  const [disabledModules, setDisabledModules] = useState({});
  const tablas = [
    {
      title: "Tanques",
      modulo: "tanques",
      descripcion:
        "Suscribirse al modulo de vencimientos de los tanques , prueba hidraulica",
    },
    {
      title: "Vehiculos",
      modulo: "vehiculos",
      descripcion:
        "Suscribirse al modulo de vencimientos de vehiculos , prueba hidraulica ,vtv ",
    },
    {
      title: "Choferes",
      modulo: "choferes",
      descripcion:
        "Suscribirse al modulo de vencimientos de los choferes , licencia de conducir ",
    },
  ];
  function CustomCard({ title, modulo, descripcion, accion, disabled }) {
    return (
      <Card
        sx={{
          minWidth: 275,
          padding: 5,
          backgroundColor: "#A7D6DA",
          borderRadius: 7,
        }}
      >
        <CardContent>
          <Typography variant="h5" component="div">
            {title}
          </Typography>
          {/*  <Typography sx={{ color: "text.secondary", mb: 1.5 }}>
            {modulo}
          </Typography> */}
          <Typography variant="body2">
            {descripcion}
            <br />
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={() => accion(modulo)}
            disabled={disabled}
          >
            {disabled ? `Suscripto ✔` : "Suscribirse"}
          </Button>
        </CardActions>
      </Card>
    );
  }
  return (
    <Container maxWidth="lg">
      <Navbar />
      <Grid container spacing={2} marginTop={10}>
        {tablas.map((tabla) => (
          <Grid item xs={6} key={tabla.modulo}>
            <CustomCard
              title={tabla.title}
              modulo={tabla.modulo}
              descripcion={tabla.descripcion}
              accion={guardarSuscripcion}
              disabled={disabledModules[tabla.modulo] || false}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default TablaSuscripciones;
